import { StandardPropertiesHyphen } from "csstype";

export const cssFromObject = (object?: StandardPropertiesHyphen) =>
  typeof object === "object"
    ? Object.keys(object)
        .map(
          (key) => `${key}: ${object[key as keyof StandardPropertiesHyphen]};`
        )
        .join("\n")
    : "";

/**
 * Normalizes a CSS length value into a string with a unit. Bare numbers and
 * numeric strings are treated as pixels; empty strings become "0"; any other
 * string (already carrying a unit) is returned unchanged.
 */
export const parseUnit = (value: string | number): string => {
  if (typeof value === "number") {
    return `${value}px`;
  }
  if (value === "") {
    return "0";
  }
  return /^\d+$/.test(value) ? `${value}px` : value;
};
